"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrapperGS = void 0;
const gs = require("../");
const GS_js_1 = require("./GS.js");
class WrapperGS {
    constructor(elOrTmplName, asTemplate = false) {
        const wr = this;
        let tmplWr;
        //getting template wrapper
        if (typeof elOrTmplName === 'string') {
            const tmplName = elOrTmplName.toLowerCase();
            tmplWr = gs.TemplateGS.GetTmpl(tmplName);
        }
        else if (asTemplate) {
            tmplWr = gs.w(elOrTmplName);
        }
        else
            this.el = elOrTmplName;
        //if there is tmpl
        if (tmplWr) {
            //getting template tag arguments
            const attrsMap = tmplWr.getAttrsObj();
            if (attrsMap.has('id'))
                attrsMap.delete('id');
            const attrs = {};
            for (const k of attrsMap.keys()) {
                attrs[k] = attrsMap.get(k);
            }
            //getting target tag 
            let tagName = tmplWr.el.tagName.toLowerCase();
            const needSetTag = tmplWr.getGSA(gs.TemplateGS.TagGSATemplateTag);
            if (needSetTag)
                tagName = needSetTag;
            //creating new Element
            if (tagName === "template")
                this.el = gs.html.div(attrs, tmplWr.html);
            else
                this.el = gs.html.tag(tagName, attrs, tmplWr.html);
        }
        if (this.el[WrapperGS.NameOfInstInPropOfEl])
            return this.el[WrapperGS.NameOfInstInPropOfEl];
        this.el[WrapperGS.NameOfInstInPropOfEl] = this;
        if (tmplWr)
            this._fillTmpl();
        ///Processing extends initDataArgs
        for (const key of WrapperGS._ImplementWrapperByGSA.keys()) {
            if (!this.getGSA(key))
                continue;
            WrapperGS._ImplementWrapperByGSA.get(key)(this);
        }
        ///Processing extends initClassArgs
        this.el.classList.forEach((cl) => {
            if (!cl)
                return;
            if (WrapperGS._ImplementWrapperByClassArg.has(cl))
                WrapperGS._ImplementWrapperByClassArg.get(cl)(tmplWr);
        });
    }
    static ToValued(wr) {
        if (!gs.def.hasProp(wr, "value", gs.Types.NotFunction))
            return undefined;
        return wr;
    }
    static ToAsyncValued(wr) {
        if (!gs.def.hasProp(wr, "setValueAsync", gs.Types.Function))
            return undefined;
        if (!gs.def.hasProp(wr, "getValueAsync", gs.Types.Function))
            return undefined;
        return wr;
    }
    static ToSelectable(wr) {
        if (!gs.def.hasProp(wr, "selected", gs.Types.Bool))
            return undefined;
        if (!gs.def.hasProp(wr, "select", gs.Types.Function))
            return undefined;
        if (!gs.def.hasProp(wr, "unselect", gs.Types.Function))
            return undefined;
        return wr;
    }
    static ToValidable(wr) {
        if (!gs.def.hasProp(wr, "valid", gs.Types.Function))
            return undefined;
        return wr;
    }
    static ToAsyncValidable(wr) {
        if (!gs.def.hasProp(wr, "validAsync", gs.Types.Function))
            return undefined;
        return wr;
    }
    static InjectComponents(component, fullNameForTmplFile) {
        const lib = WrapperGS._InjectComponents;
        if (!lib.has(fullNameForTmplFile)) {
            lib.set(fullNameForTmplFile, component);
            return;
        }
        if (lib.get(fullNameForTmplFile) != component)
            throw new Error(`Component with fullName '${fullNameForTmplFile}' dublicated!`);
    }
    static ReInjectComponents(fullNameForTmplFile) {
        WrapperGS._InjectComponents.delete(fullNameForTmplFile);
    }
    static GetInjectedComponentConstructor(fullNameForTmplFile) {
        if (!WrapperGS._InjectComponents.has(fullNameForTmplFile))
            return undefined;
        return WrapperGS._InjectComponents.get(fullNameForTmplFile);
    }
    static ExtendComponentsByTagClass(component) {
        const lib = WrapperGS._ExtendComponentsByTagClass;
        if (!lib.has(component.TagClassName)) {
            lib.set(component.TagClassName, component);
            return;
        }
        if (lib.get(component.TagClassName) != component)
            throw new Error(`Component TagClass '${component.TagClassName}' dublicated!`);
    }
    /**Return all tagClasses which extends components */
    static GetExtendComponentsTagClasses() { return [...WrapperGS._ExtendComponentsByTagClass.keys()]; }
    static ExtendComponentsByHTMLElement(...components) {
        WrapperGS._ExtendComponentsByHTMLElement.push(...components);
    }
    static ReduceComponentsByHTMLElement(component) {
        gs.array.remove(WrapperGS._ExtendComponentsByHTMLElement, component);
    }
    /**
     * Call linked function for each wrapper who has specific dataArg
     * @param dataArg
     * @param func (wr:Wrapper affected, rootWr:Wrapper of template)
     */
    static ImplementWrapperByGSA(gsa, func) {
        WrapperGS._ImplementWrapperByGSA.set(gsa, func);
    }
    /**
     * Call linked function for each wrapper who has specific dataArg
     * @param dataArg
     * @param func (wr:Wrapper affected, rootWr:Wrapper of template)
     */
    static ImplementWrapperByClassArg(classArg, func) {
        WrapperGS._ImplementWrapperByClassArg.set(classArg, func);
    }
    static get NameOfInstInPropOfEl() { return 'z_gswrapper_inst'; }
    static IsWrapper(el) { return el instanceof WrapperGS; }
    /**
     * Wrap element in WrapperGs
     * Происходит вокруг уже существующего элемента, поэтому мы можем инжектировать другие компоненты в отличии от конструктора
     * Где инжектировать нельзя кроме как через наследование
     * @param el
     */
    static Wrap(el) {
        if (WrapperGS.IsWrapper(el))
            return el;
        if (el.nodeType !== 1)
            return;
        if (el[WrapperGS.NameOfInstInPropOfEl])
            return el[WrapperGS.NameOfInstInPropOfEl];
        const htmlEl = el;
        // if (asTmpl || htmlEl.tagName.toLocaleLowerCase() === "template" || htmlEl.classList.contains("template")) 
        // {
        //     //wrapping extendsByTagClass
        //     for (const key of WrapperGS._ExtendComponentsByTagClass.keys())
        //         if (htmlEl.classList.contains(key)) {
        //             const c = WrapperGS._ExtendComponentsByTagClass.get(key);
        //             return new c(htmlEl);
        //         }
        //     return new WrapperGS(el);
        // }
        //replacing element if has component
        // const cmpName = htmlEl.getAttribute('data-' + WrapperGS.AttrDataComponentInject);
        // if (cmpName)            
        //     if (WrapperGS._InjectComponents.has(cmpName)) {
        //         const c = WrapperGS._InjectComponents.get(cmpName)
        //         const cArgs = htmlEl.getAttribute('data-' + WrapperGS.AttrDataComponentInjectArgs);
        //         let cmp: WrapperGS;
        //         if (cArgs)
        //             cmp = new c(JSON.parse(cArgs)); else
        //             cmp = new c();
        //         if (htmlEl.parentNode) {
        //             htmlEl.after(cmp.el);
        //             htmlEl.parentNode.removeChild(htmlEl);
        //         }
        //     }
        //wrapping extendsByTagClass
        for (const key of WrapperGS._ExtendComponentsByTagClass.keys())
            if (htmlEl.classList.contains(key)) {
                const c = WrapperGS._ExtendComponentsByTagClass.get(key);
                return new c(htmlEl);
            }
        //wrapping extendsByHTMLElementValidationFunc
        for (const c of WrapperGS._ExtendComponentsByHTMLElement)
            if (c.ForHTMLElement(htmlEl))
                return new c(htmlEl);
        return new WrapperGS(el);
    }
    getControl(name) {
        if (!this._controls)
            return undefined;
        return this._controls.get(name);
    }
    _fillTmpl() {
        const rootWr = this;
        this._controls = new Map();
        const rootCtrls = this._controls;
        const lang = gs.localization.getLang();
        const locArg = "loc-" + lang;
        const locPlaceholderArg = "loc-placeholder-" + lang;
        /**Fill element */
        const fillData = (wr) => {
            //If it's top-level template, remove it
            if (wr.el.tagName.toLowerCase() === "template") {
                wr.cut();
                return;
            }
            const gs_ins = wr.getGSA("ins");
            if (gs_ins) {
                const insConstructor = WrapperGS.GetInjectedComponentConstructor(gs_ins);
                let ins;
                if (insConstructor)
                    ins = new insConstructor();
                else
                    try {
                        ins = new WrapperGS(gs_ins);
                    }
                    catch (e) { }
                if (ins) {
                    wr.getAttrsObj().forEach((v, k) => { if (k.toLowerCase() == "class")
                        return; ins.attr(k, v); });
                    wr.el.classList.forEach((cl) => ins.addClass(cl));
                    wr.replace(ins);
                    //Text injection
                    const txts = wr.q('text').all;
                    if (txts.length > 0 && ins._controls) {
                        const ins_ctrls = ins._controls;
                        for (const txt of txts) {
                            const ctrlName = txt.attr(gs.TemplateGS.TagGSAControlName);
                            if (!ctrlName)
                                continue;
                            if (ins_ctrls.has(ctrlName))
                                ins_ctrls.get(ctrlName).text = txt.text;
                        }
                    }
                    ins.removeGSA("ins");
                    ins.setGSA("ins-ed", gs_ins);
                    fillData(ins);
                    return;
                }
            }
            let controlName = wr.getGSA(gs.TemplateGS.TagGSAControlName);
            if (wr === rootWr)
                controlName = undefined; //Контроль на сам шаблон может быть только во вложенности, а значит на root объекте его быть не может
            if (controlName)
                rootCtrls.set(controlName, wr);
            //Check - is it template
            const tmplName = wr.getGSA(gs.TemplateGS.TagGSATemplateName);
            if (tmplName)
                //It's nested template
                if (rootWr !== wr) {
                    const constructFunc = gs.TemplateGS.Constructors.get(tmplName);
                    if (!constructFunc)
                        return;
                    const newW = constructFunc(tmplName);
                    wr.replace(newW);
                    if (controlName) {
                        rootCtrls.delete(controlName);
                        rootCtrls.set(controlName, newW);
                    }
                    return;
                }
            //Локализация
            const locText = wr.getGSA(locArg);
            if (locText)
                wr.text = locText;
            const locPlaceholder = wr.getGSA(locPlaceholderArg);
            if (locPlaceholder)
                wr.el.placeholder = locPlaceholder;
            //Рекурсивный обход для не вложенных шаблонов
            wr.getChildren().map(fillData);
        };
        rootWr.q('*'); //преобертка, чтобы была последовательная инициализация
        fillData(rootWr);
        rootWr.q('template').cut();
    }
    q(selector) { return new GS_js_1.GS(selector, this.el); }
    hasClass(className) { var _a, _b; return (_b = (_a = this.el.classList) === null || _a === void 0 ? void 0 : _a.contains(className)) !== null && _b !== void 0 ? _b : false; }
    addClass(className) { if (!this.el.classList)
        return; if (!this.hasClass(className))
        this.el.classList.add(className); }
    addClasses(classesNames) { for (const c of classesNames)
        this.addClass(c); }
    removeClass(className) { if (!this.el.classList)
        return; if (this.hasClass(className))
        this.el.classList.remove(className); }
    flipClass(className) { if (!this.el.classList)
        return; if (this.hasClass(className))
        this.removeClass(className);
    else
        this.addClass(className); }
    getElement(el) {
        if (WrapperGS.IsWrapper(el))
            return el.el;
        else
            return el;
    }
    /**Add after this wrapper*/
    after(el) { this.el.after(this.getElement(el)); }
    /**Add before this wrapper*/
    before(el) { this.el.before(this.getElement(el)); }
    /**Add to start of childrens*/
    prepend(el) { this.el.prepend(this.getElement(el)); }
    /**Add to end of childrens*/
    append(el) { this.el.append(this.getElement(el)); }
    /**Remove this wrapper */
    cut() { this.el.remove(); }
    /**
     * Replace this wrapper by another
     * @param {WrapperGS} w
     */
    replace(by) {
        if (this.el.parentNode === null)
            return;
        const el = this.getElement(by);
        this.before(el);
        this.cut();
    }
    ;
    get isEnabled() { return !this.hasClass(WrapperGS.ClassNameDisabled); }
    disable() { this.el[WrapperGS.ClassNameDisabled] = true; this.addClass(WrapperGS.ClassNameDisabled); }
    ;
    enable() { this.el[WrapperGS.ClassNameDisabled] = false; this.removeClass(WrapperGS.ClassNameDisabled); }
    ;
    enableFlip() { this.isEnabled ? this.disable() : this.enable(); }
    ;
    enableSet(value) { value ? this.enable() : this.disable(); }
    ;
    get isShowed() { return !this.hasClass(WrapperGS.ClassNameHide); }
    hide() { this.addClass(WrapperGS.ClassNameHide); }
    ;
    show() { this.removeClass(WrapperGS.ClassNameHide); }
    ;
    showFlip() { this.isShowed ? this.hide() : this.show(); }
    ;
    showSet(value) { value ? this.show() : this.hide(); }
    ;
    get isActive() { return this.hasClass(WrapperGS.ClassNameActive); }
    inactive() { this.removeClass(WrapperGS.ClassNameActive); }
    ;
    active() { this.addClass(WrapperGS.ClassNameActive); }
    ;
    activeFlip() { this.isActive ? this.inactive() : this.active(); }
    ;
    activeSet(value) { value ? this.inactive() : this.active(); }
    scrollTo() {
        let e = this.el, posX = 0, posY = 0;
        while (e) {
            posX += e.offsetLeft;
            posY += e.offsetTop;
            e = gs.def.toType(e.offsetParent, HTMLElement);
        }
        window.scrollTo(posX, posY);
    }
    ;
    get text() { return this.el.innerText; }
    set text(value) { this.el.innerText = value; }
    get html() { return this.el.innerHTML; }
    set html(value) { this.el.innerHTML = value; }
    attr(name, value) {
        if (value === undefined)
            return this.el.getAttribute(name);
        if (value === null)
            this.el.removeAttribute(name);
        else
            this.el.setAttribute(name, value);
    }
    attrRemove(name) { this.attr(name, null); }
    /**
     * Return obj this attrs
     * */
    getAttrsObj() {
        const map = new Map();
        let i = 0;
        while (this.el.attributes[i]) {
            const k = this.el.attributes[i].name;
            map.set(k, this.el.getAttribute(k));
            i++;
        }
        return map;
    }
    getData(name) { const d = this.attr('data-' + name); if (!d)
        return '';
    else
        return d; }
    removeData(name) { this.attr('data-' + name, null); }
    setData(name, value) { this.attr('data-' + name, value); }
    getGSA(name) { const d = this.attr('gs-' + name); if (!d)
        return '';
    else
        return d; }
    removeGSA(name) { this.attr('gs-' + name, null); }
    setGSA(name, value) { this.attr('gs-' + name, value); }
    /**Get children without deep */
    getChildren() {
        const list = [];
        this.el.childNodes.forEach(e => {
            const wr = gs.w(e);
            if (wr)
                list.push(wr);
        });
        return list;
    }
    /**Get all children include children of children*/
    getAllChildren() {
        const list = [];
        function searchChildren(el) {
            el.childNodes.forEach(e => {
                const wr = gs.w(e);
                if (wr)
                    list.push(wr);
                searchChildren(e);
            });
        }
        searchChildren(this.el);
        return list;
    }
    set onclick(value) { this.el.onclick = value; }
}
exports.WrapperGS = WrapperGS;
WrapperGS.AttrDataComponentInject = "cmp";
WrapperGS.AttrDataComponentInjectArgs = "cmp_args";
WrapperGS.AttrDataTemplateNotForInject = "no_inj";
WrapperGS.ClassNameTemplate = "tmpl";
WrapperGS.ClassNameHide = "d-none";
WrapperGS.ClassNameActive = "active";
WrapperGS.ClassNameDisabled = "disabled";
WrapperGS._InjectComponents = new Map();
WrapperGS._ExtendComponentsByTagClass = new Map();
WrapperGS._ExtendComponentsByHTMLElement = [];
WrapperGS._ImplementWrapperByGSA = new Map();
WrapperGS._ImplementWrapperByClassArg = new Map();
WrapperGS.ImplementWrapperByGSA('size_ration', (wr) => {
    const ratio = parseFloat(wr.getGSA('size_ratio'));
    const resize = () => { wr.attr('height', (wr.el.clientWidth / ratio).toString()); };
    window.addEventListener('resize', resize);
    setTimeout(resize, 100);
});
WrapperGS.ImplementWrapperByGSA('set_src_after', (wr) => {
    const imgHtml = gs.def.toType(wr.el, HTMLImageElement);
    if (imgHtml)
        imgHtml.src = wr.getGSA('set_src_after');
});
WrapperGS.ImplementWrapperByGSA('scroll_after_focusin', (wr) => {
    const scrollHandler = function (e) {
        const el = e.target;
        if (el.scrollIntoView)
            el.scrollIntoView();
    };
    wr.el.addEventListener('focusin', scrollHandler);
});
//# sourceMappingURL=WrapperGS.js.map